import { SelectOption } from 'formComponents/Select/types';
import { useSelector } from 'react-redux';
import * as React from 'react';
// eslint-disable-next-line import/no-cycle
import { skontodefinitionenSelector } from 'store/lookups/selector';
import { callApi, Controller } from './useApi';

export interface Skontodefinition {
    art: number;
    text: string;
    zahlfrist: number;
    skP1: number;
    skF1: number;
    skP2: number;
    skF2: number;
    archiv: boolean;
}

export const defaultSkontodefinition: Skontodefinition = {
    art: 0,
    text: '',
    zahlfrist: 0,
    skP1: 0,
    skF1: 0,
    skP2: 0,
    skF2: 0,
    archiv: false,
};

export function useSkontodefinitionenAsOptions(): SelectOption[] {
    // const skontodefinitionen = useSkontodefinitionen();
    const skontodefinitionen = useSelector(skontodefinitionenSelector);

    return React.useMemo<SelectOption[]>(() => {
        return skontodefinitionen
            .filter((skontodefinition) => !skontodefinition.archiv)
            .map(
                (skontodefinition) =>
                    ({ value: skontodefinition.art.toString(), label: skontodefinition.text } as SelectOption),
            );
    }, [skontodefinitionen]);
}

export async function addSkontodefinition(skontodefinition: Skontodefinition): Promise<void> {
    return callApi<void>(Controller.skontodefinition + '/add', { skontodefinition });
}

export async function updateSkontodefinition(skontodefinition: Skontodefinition): Promise<void> {
    return callApi<void>(Controller.skontodefinition + '/update', { skontodefinition });
}

export async function deleteSkontodefinition(skontodefinition: Skontodefinition): Promise<void> {
    return callApi<void>(Controller.skontodefinition + '/update', { skontodefinition });
}
